


//Methods
var forEach = function (array, callback, scope) {
  // Usage:
  // optionally change the scope as final parameter too, like ECMA5
  // var myNodeList = document.querySelectorAll('li');
  // forEach(myNodeList, function (index, value) {
  //   console.log(index, value); // passes index + value back!
  // });
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

// 
(function($) {
  $(document).ready(function(){
    // Product Quant Updates
    $('.quant_button').click(function() {
      var oldval = $(this).siblings('.quant_input').val();
      if ( $(this).hasClass('quant_minus') && oldval > 1 ) {
        var newval = (oldval * 1) - 1;
        $(this).siblings('.quant_input').val(newval);
      }
      else if ( $(this).hasClass('quant_plus') ) {
        var newval = (oldval * 1) + 1;
        $(this).siblings('.quant_input').val(newval);
      }
      
    });
    
    // Added class on load instead of via liquid in case js fails
    // $('.template-index').addClass('bottomed-out');

    // Older scripts
    var didScroll;
    var lastScrollTop = 0;
    var delta = 150;

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down
        if (st > lastScrollTop ){
            // Scroll Down
                $('body').removeClass('upwards').addClass('downwards');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('body').removeClass('downwards').addClass('upwards');
            }
        }

        lastScrollTop = st;
    }

    $('#footer-main').waypoint(function(direction) {
      if (direction === 'down') {
        $('body').addClass('bottomed-out');
        console.log("footer hit on the way down");
      }
      else {
        $('body').removeClass('bottomed-out');
      }

    }, { offset: 200 });

    $('#homeslidewrap').waypoint(function(direction) {
      if (direction === 'up') {
        $('body').addClass('bottomed-out');
      }
      else {
        $('body').removeClass('bottomed-out');
      }

    }, { offset: '-90%' });


  });
}) ( jQuery );
